const _135 = (results, winloss) => {
    const plan = [1, 3, 5, 2, 6, 10];
    let lostInRow = 0;
    const latest = winloss.filter(wl => wl !== 0).reverse();
    for (let i = 0; i < latest.length; i++) {
        if (latest[i] <= 0) {
            lostInRow ++
        } else {
            break;
        }
    }

    return plan[lostInRow % plan.length]
}

export default (results, winloss) => {
    return new Promise((resolve) => {
        setTimeout( () => {
            resolve(_135(results, winloss));
        }, 100)
    })
}